import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { CreateClientModal } from '../CreateClientModal';
export function useOpenCreateClientModal() {
    const { showModal } = useOverlayContext();
    return useCallback(()=>showModal({
            biName: 'create_client',
            openBottomSheetOnMobile: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(CreateClientModal, {
                    dismissModal: dismissModal
                });
            }
        }), [
        showModal
    ]);
}
